var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page bar-content"},[_c('Nav',{attrs:{"calculate":false}}),_c('div',{staticClass:"page-container"},[_c('router-view',{key:_vm.key})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }